// frontend/src/App.js

import React from 'react';
import { BrowserRouter as Router, Navigate, Routes, Route } from 'react-router-dom';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import dayjs from 'dayjs';
import 'dayjs/locale/en-gb';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import theme from './theme';
import { AuthProvider } from './contexts/AuthContext';
import { SnackbarProvider } from './contexts/SnackbarContext';
import Orders from './components/Orders';
//import BagOrders from './components/BagOrders';
//import History from './components/History';
import GrafanaKpi from './components/GrafanaKpi';
import Login from './components/Login';
import Profile from './components/Profile';
import UserManagement from './components/UserManagement';
import Dashboard from './components/Dashboard';
import PrivateRoute from './components/PrivateRoute';
import Clients from './components/Clients';
import AccessDenied from './components/AccessDenied';
import Report from './components/Report';
import Logs from './components/Logs';
import OperationDashboardKPI from './components/OperationDashboardKPI';
import KeyEventsOrderStatistics from './components/KeyEventsOrderStatistics';
import ReportsDashboard from './components/ReportsDashboard';
import LinxDispatch from './components/LinxDispatch';
import ManageBatches from './components/ManageBatches';
import GenericKpiDashboard from './components/KpiHourlyAndDispatchDashboard';
import FunkyPigeonKpiDashboard from './components/FunkyPigeonKpiDashboard';
import BranstonConverter from './components/BranstonConverter';
import FlushMoonpigCardOrders from './components/FlushMoonpigCardOrders';
import OperationalReporting from './components/OperationalReporting';
import OperationalReportingSnapshot from './components/OperationalReportingSnapshot';
import OtsDotReport from './components/OtsDotReport';
import MonthlyDispatchTracker from './components/MonthlyDispatchTracker';
import OrderTracker from './components/OrderTracker';
import BatchPrintJobs from './components/BatchPrintJobs';
import PrintBatchAudit from './components/PrintBatchAudit';
import PrintWorkflowAdmin from './components/PrintWorkflowAdmin';
dayjs.locale('en-gb');

function App() {
    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <AuthProvider>
                <SnackbarProvider>
                    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
                        <Router>
                            <Routes>
                                <Route path="/login" element={<Login />} />
                                <Route path="/orders" element={<PrivateRoute component={Orders} />} />
                                {/*<Route path="/bagorders" element={<PrivateRoute component={BagOrders} />} />*/}
                                {/*<Route path="/history" element={<PrivateRoute component={History} />} />*/}
                                <Route path="/grafanakpi" element={<PrivateRoute component={GrafanaKpi} />} />
                                <Route path="/moonpig-flush-card-orders" element={<FlushMoonpigCardOrders />} />
                                <Route path="/profile" element={<PrivateRoute component={Profile} />} />
                                <Route path="/user-management" element={<PrivateRoute component={UserManagement} />} />
                                <Route path="/dashboard" element={<PrivateRoute component={Dashboard} />} />
                                <Route path="/kpi-generic" element={<PrivateRoute component={GenericKpiDashboard} />} />
                                <Route path="/funky-pigeon-kpi" element={<PrivateRoute component={FunkyPigeonKpiDashboard} />} />
                                <Route path="/clients" element={<PrivateRoute component={Clients} />} />
                                <Route path="/reports" element={<PrivateRoute component={Report} />} />
                                <Route path="/operational-reporting" element={<PrivateRoute component={OperationalReporting} />} />
                                <Route path="/operational-reporting-snapshot" element={<PrivateRoute component={OperationalReportingSnapshot} />} />
                                <Route path="/ots-dot-report" element={<PrivateRoute component={OtsDotReport} />} />
                                <Route path="/monthly-dispatch-tracker" element={<PrivateRoute component={MonthlyDispatchTracker} />} />
                                <Route path="/reports-dashboard" element={<PrivateRoute component={ReportsDashboard} />} />
                                <Route path="/operation-dashboard-kpi" element={<PrivateRoute component={OperationDashboardKPI} />} />
                                <Route path="/key-events-order-statistics" element={<PrivateRoute component={KeyEventsOrderStatistics} />} />
                                <Route path="/logs" element={<PrivateRoute component={Logs} permission="ViewLogs" />} />
                                <Route path="/access-denied" element={<AccessDenied />} />
                                <Route path="/linx-dispatch" element={<PrivateRoute component={LinxDispatch} />} />
                                <Route path="/order-tracker" element={<PrivateRoute component={OrderTracker} allowedRoleIds={[1, 3]} />} />
                                <Route path="/batch-print" element={<PrivateRoute component={BatchPrintJobs} permission="PrintProductionJobs" />} />
                                <Route path="/biscuiteers-print-jobs" element={<Navigate to="/batch-print" replace />} />
                                <Route path="/print-batch-audit" element={<PrivateRoute component={PrintBatchAudit} permission="ViewPrintBatchAudit" />} />
                                <Route path="/print-workflow-settings" element={<PrivateRoute component={PrintWorkflowAdmin} permission="ManagePrintWorkflowConfig" />} />
                                <Route path="/manage-batches" element={<PrivateRoute component={ManageBatches} />} />
                                <Route path="/branston-converter" element={<PrivateRoute component={BranstonConverter} />} />
                                <Route path="/" element={<PrivateRoute component={Dashboard} />} />
                            </Routes>
                        </Router>
                    </LocalizationProvider>
                </SnackbarProvider>
            </AuthProvider>
        </ThemeProvider>
    );
}

export default App;
